import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/layout/footer.css";
import logo from "../assets/img/logos/kentucky-icons/Team-Kentucky-Blue_286x150.png";

function Footer() {
    return (
        <footer className="generalFooterStyle" aria-label="Site Footer">
            {/* Section 1: Subscribe Call to Action */}
            <section className="subscribeCTA" aria-labelledby="cta-heading">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 subFooter">
                            {/* Semantic heading for screen reader navigation */}
                            <h2 id="cta-heading" className="top-title-footer" style={{fontWeight: "bolder", fontSize: "25px"}}>
                                Looking for Service?
                            </h2> 
                            <p>
                                To receive Press Releases and updates on Families, Wellness and Medical information, subscribe below.
                            </p>
                        </div>
                        <div className="col">
                            {/* Alerting users to new window behavior */}
                            <Link to="https://www.chfs.ky.gov/agencies/dcbs/Pages/default.aspx" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                                Learn More <span className="sr-only">(opens in a new window)</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Enterprise Branding & Statutory Links */}
            <div className="outerContainer footerRow">
                <div className="container">
                    <div className="footer-brand">
                        <p className="m-0">Commonwealth of Kentucky</p>
                        <p className="m-0">Cabinet for Health and Family Services</p>
                    </div>

                    <div className="portal-FooterInsert">
                        <nav className="enterprise-footer-links" aria-label="Government Policies">
                            <ul className="list-unstyled list-inline">
                                <li><a href="https://www.kentucky.gov/policies/pages/default.aspx">Policies</a></li>
                                <li><a href="https://www.kentucky.gov/policies/pages/default.aspx">Security</a></li>
                                <li><a href="https://www.kentucky.gov/policies/pages/disclaimer.aspx">Disclaimer</a></li>
                                <li><a href="https://www.kentucky.gov/policies/pages/accessibility.aspx">Accessibility</a></li>
                            </ul>
                        </nav>

                        <div className="outerContainer unbridledRow">
                            {/* Required Alt Text for State Branding */}
                            <img src={logo} alt="Team Kentucky - Cabinet for Health and Family Services" />
                        </div>

                        <div className="outerContainer copyrightRow">
                            <p>
                                <a href="https://kentucky.gov">Kentucky.gov</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
